import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BaseAuthComponent } from '@layouts/default/layouts/guest/pages/home/components/base-auth.component';
import { AccountService } from '@layouts/default/layouts/logged/pages/account/account.service';
import { PhDropComponent } from '@shared/components/ph-drop/ph-drop.component';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { HeaderService } from '@shared/services/header.service';
import { MenuService } from '@shared/services/menu.service';
import { ItemMenu } from '@shared/models/item-menu.model';
import { Menu } from '@shared/interfaces/menu/menu.interface';
import { RoutesPath } from '@shared/routes-path';

@Component({
  selector: 'app-header-desktop',
  templateUrl: './header-desktop.component.html',
  styleUrls: ['./header-desktop.component.scss'],
})
export class HeaderDesktopComponent extends BaseAuthComponent implements Menu {
  cartListLength: number = 0;
  ukraineUrl: boolean = false;
  instagramLink: string;
  facebookLink: string;
  headerLink: string = RoutesPath.default.home;
  logoSrc: string = 'assets/img/logo.svg';

  @Input() eventCategory;
  @Input() notificationsUnseen: number = null;
  @Output() inputFocusEmitter: EventEmitter<any> = new EventEmitter();
  @Output() getStatistictEmitter: EventEmitter<any> = new EventEmitter();
  @Output() cartListLengthEmitter: EventEmitter<any> = new EventEmitter();
  @ViewChild('dropNotification') dropNotification: PhDropComponent;
  @Input() menuItems: ItemMenu[];

  constructor(
    public accountService: AccountService,
    public route: ActivatedRoute,
    public router: Router,
    public header: HeaderService,
    public menuService: MenuService
  ) {
    super();

    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.menuItems = this.menuService.loadMenu();
        this.facebookLink = this.menuService.facebookLink();
        this.instagramLink = this.menuService.instagramLink();
        this.ukraineUrl = this.menuService.isUkraineUrl();
        this.headerLink = this.menuService.getHeaderLink();
        this.logoSrc = this.menuService.getLogo();
      }
    });
  }

  isColored(pages: Array<string>) {
    const isWelcomePage = this.router.url === '/';
    const filtered = pages.filter((page) => this.router.url.search(page) > 0);
    return isWelcomePage || filtered.length > 0;
  }

  onCloseNotifications() {
    this.getStatistictEmitter.emit();
    this.dropNotification.close();
  }

  updateCartListLabel(length) {
    this.cartListLength = length;
    this.cartListLengthEmitter.emit(length);
  }

  setAutoFocus(value) {
    this.storage.put('autofocus', value);
  }

  removeAutofocus() {
    this.storage.delete('autofocus');
  }

  isActive(page: string) {
    return this.menuService.isActive(page);
  }

  onAvatarClick() {
    this.router.navigate([
      '/' +
        this.RoutesPath.default.profile +
        '/' +
        this.storage.user.id +
        '/' +
        this.RoutesPath.default.profileTabs.summary,
    ]);
  }
}
